module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyAgMAAADXW5YtAAAADFBMVEUAh1Gq18X///+p18Sq7mSIAAAAG0lEQVR4AWOAAalVELAGJjDyZEZlRmVGZUZlAA5EDyjCFKrBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/ng.png
// module id = biOc
// module chunks = 0